import InfoSection from "datalign-module-template/models/info-sections";
import React from "react";

const OneColumnsSection = ({ infoSection }: { infoSection: InfoSection }) => {
  return (
    <article className="card span-12" style={{ width: "100%" }}>
      <h3>{infoSection.name}</h3>
      <div>{infoSection.content}</div>
    </article>
  );
};

export default OneColumnsSection;
